<template>
    <div class="mobile-event-cards-container">
        <div
            v-for="(event, indx) in eventsInfo"
            :key="indx"
            :style="eventCardStyle"
            @click="onEventClicked(event)"
            class="event-card-wrapper"
        >
            <div class="card-top-section">
                <img :src="eventImage(indx)" alt="event-image" />
            </div>
            <div class="card-bottom-section">
                <p class="event-date">
                    {{ eventDate(indx) }}
                </p>
                <p
                    v-if="eventName(indx) && eventName(indx) != 'Add event title'"
                    class="event-name"
                >
                    {{ eventName(indx) }}
                </p>
                <div class="event-info-wrapper">
                    <p class="event-age">
                        {{ `${event.min_age ? event.min_age + '+' : 'All Ages'}` }}
                    </p>
                    <p class="event-time">Doors at {{ eventTime(event) }}</p>
                    <p v-if="event.cover_cost" class="cover-charge">
                        {{ `$${event.cover_cost} Cover` }}
                    </p>
                </div>
                <div v-if="event.array_keywords.length" class="event-vibes-wrapper">
                    <p class="vibe-title">Vibe:</p>
                    <p class="vibe-keywords">
                        {{ eventVibes(event) }}
                    </p>
                </div>
                <div v-if="event.bookedArtists.length" class="event-featuring-wrapper">
                    <p class="featured-title">Featuring:</p>
                    <div
                        v-for="(artist, indx) in event.bookedArtists"
                        :key="indx"
                        class="featured-artist"
                    >
                        <img
                            class="featured-artist-avatar"
                            :src="artist.avatar"
                            alt="artist-avatar"
                        />
                        <p class="featured-artist-name">{{ artist.band_name }}</p>
                    </div>
                </div>
                <!-- @TODO: uncomment once feature is ready
                 <div v-if="!venue" class="card-divider"></div>
                 <div v-if="!venue" class="card-actions">
                     <button class="add-to-calendar-btn">Add to Calendar</button>
                     <button class="share-btn">Share</button>
                 </div>
                -->
            </div>
        </div>
    </div>
</template>
<script>
    import { DAYS, SHORT_MONTHS } from '@/constants/calendar'
    const URLS = {
        images: {
            defaultEventImage: '/images/default-artist-event.png'
        }
    }
    export default {
        name: 'MobileEventCards',
        props: {
            eventsInfo: {
                required: true,
                type: Array
            },
            eventClickable: {
                required: false,
                type: Boolean,
                default: false
            },
            renderShortDate: {
                required: false,
                type: Boolean,
                default: false
            },
            profile: {
                type: Boolean,
                default: false,
                required: false
            },
            venue: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        computed: {
            URLS: () => URLS,
            eventCardStyle: (self) => {
                const styles = {}

                if (self.eventClickable) {
                    styles.cursor = 'pointer'
                }
                if (self.venue) {
                    styles.height = 'fit-content'
                }

                return styles
            },
            eventImage: (self) => (indx) => {
                if (
                    (!self.eventsInfo[indx].image &&
                        !self.eventsInfo[indx].venue.venue_info.main_avatar) ||
                    self.eventsInfo[indx].venue.venue_info.main_avatar.includes(
                        '/images/global/default.png'
                    )
                ) {
                    return self.URLS.images.defaultEventImage
                } else if (self.eventsInfo[indx].image) {
                    return self.eventsInfo[indx].image
                } else {
                    return self.eventsInfo[indx].venue.venue_info.main_avatar
                }
            },
            eventDate: (self) => (indx) => {
                if (self.eventsInfo[indx].start_date) {
                    if (self.renderShortDate) {
                        return self.getShortDate(self.eventsInfo[indx].start_date)
                    }

                    return self.eventsInfo[indx].start_date
                }

                return 'Add date'
            },
            eventTime: () => (event) => {
                if (event.start_time)
                    return event.start_time
                        .substring(0, event.start_time.indexOf('M') + 1)
                        .replaceAll(' ', '')
                return 'N/A'
            },
            eventName: (self) => (indx) => {
                if (self.eventsInfo[indx].event_name) {
                    return self.eventsInfo[indx].event_name
                } else if (self.profile && !self.eventsInfo[indx].event_name) {
                    return ''
                } else {
                    return 'Add event title'
                }
            },
            eventVibes: () => (event) => {
                if (event.array_keywords.length) {
                    return event.array_keywords.join(', ')
                }

                return ''
            }
        },
        methods: {
            onEventClicked(event) {
                if (this.eventClickable) {
                    window.open(`/event/show/${event.id}`, '_blank')
                }
            },
            getShortDate(d) {
                let dateArr = d.split(',')
                let month = dateArr[0].split(' ')[0]
                let day = dateArr[0].split(' ')[1]
                let date = new Date(d)

                return `${DAYS[date.getDay()]}, ${SHORT_MONTHS[month]} ${this.formatDay(day)}`
            },
            formatDay(day) {
                switch (day[day.length - 1]) {
                    case '1':
                        return `${day}st`
                    case '2':
                        return `${day}nd`
                    case '3':
                        return `${day}rd`
                    default:
                        return `${day}th`
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    $smallMobile: 350px;
    @media screen and (max-width: $smallMobile) {
        .event-card-wrapper {
            min-width: 280px !important;
        }
    }
    .mobile-event-cards-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        min-width: 280px;
        max-width: 100%;
        min-height: 561px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        gap: 6px;
        overflow-x: scroll;
        white-space: nowrap;

        .event-card-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            border-radius: 15px 15px 15px 15px;
            background: #262626;
            max-width: 100%;
            min-width: 327px;

            .card-top-section {
                min-width: 280px;
                max-width: 100%;
                width: 100%;
                min-height: 247px;
                border-radius: 15px 15px 0px 0px;

                img {
                    border-radius: 15px 15px 0px 0px;
                    object-fit: cover;
                    width: 100%;
                    min-width: 280px;
                    max-width: 100%;
                    min-height: 247px;
                }
            }
            .card-bottom-section {
                padding: 20px 16px;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                gap: 6px;

                .event-date {
                    color: #acacac;
                    font-family: Instrument Sans;
                    font-size: 22px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 120%;
                    letter-spacing: -0.22px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .event-name {
                    overflow: hidden;
                    color: #acacac;
                    text-overflow: ellipsis;
                    font-family: Instrument Sans;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                    text-wrap: nowrap;
                    max-width: 295px;
                }
                .event-info-wrapper {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 18px;
                    max-width: 295px;
                    overflow: hidden;

                    .event-age,
                    .event-time,
                    .cover-charge {
                        color: #acacac;
                        font-family: Instrument Sans;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 130%;
                        letter-spacing: 0.14px;
                    }
                }
                .event-vibes-wrapper {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    overflow: hidden;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 2px;
                    padding-top: 4px;
                    padding-bottom: 10px;
                    max-width: 100%;

                    .vibe-title,
                    .vibe-keywords {
                        color: #acacac;
                        font-family: Instrument Sans;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 130%;
                        letter-spacing: 0.14px;
                        overflow: hidden;
                        text-wrap: nowrap;
                    }

                    .vibe-title {
                        min-width: fit-content;
                    }
                    .vibe-keywords {
                        max-width: 100%;
                    }
                }
                .event-featuring-wrapper {
                    max-width: 295px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 8px;
                    overflow: hidden;

                    .featured-title {
                        max-width: 69px;
                        color: #acacac;
                        font-family: Instrument Sans;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 130%;
                        letter-spacing: 0.14px;
                    }
                    .featured-artist {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 5px 12px 5px 5px;
                        border-radius: 100px;
                        border: 1px solid #acacac;
                        background: #262626;
                        gap: 10px;

                        .featured-artist-avatar {
                            border-radius: 50%;
                            width: 28px;
                            height: 28px;
                            object-fit: cover;
                        }
                        .featured-artist-name {
                            color: #acacac;
                            font-family: Instrument Sans;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 130%;
                            letter-spacing: 0.14px;
                        }
                    }
                }
                .card-divider {
                    width: 100%;
                    height: 1px;
                    background: #646464;
                    margin-top: 6px;
                }
                .card-actions {
                    padding-top: 20px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    justify-content: center;
                    gap: 8px;

                    .add-to-calendar-btn {
                        width: 100%;
                        border-radius: 100px;
                        background: #cdeb09;
                        padding: 7px 30px 9px 30px;
                        color: black;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 125%;
                    }
                    .share-btn {
                        width: 100%;
                        border-radius: 100px;
                        background: #262626;
                        padding: 7px 30px 9px 30px;
                        border: 1px solid #cdeb09;
                        color: #cdeb09;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 125%;
                    }
                }
            }
        }
    }
</style>
